export class UserWithoutCompany extends Error {
    userId: string;

    constructor(message: string, userId: string) {
      super(message);
      this.userId = userId;
    }
  }